import { Combobox } from '@headlessui/react'
import React, { FC, useState } from 'react'
import { NamedItem } from '../../models/UserProfile'
import { ChevronDownIcon } from '@heroicons/react/24/outline'

interface OrganizationComboboxProps {
  value?: NamedItem
  options: NamedItem[]
  onSelect?(value: NamedItem): void
}

const OrganizationCombobox: FC<OrganizationComboboxProps> = ({ value, onSelect, options }) => {
  const [query, setQuery] = useState('')
  const filteredOption =
    query === ''
      ? options
      : options.filter((org) =>
          org.name.toLowerCase().replace(/\s+/g, '').includes(query.toLowerCase().replace(/\s+/g, '')),
        )

  return (
    <Combobox value={value} onChange={onSelect}>
      <div className='w-full relative'>
        <div className='relative border border-gray-300 cursor-default overflow-hidden bg-white text-left rounded-md '>
          <Combobox.Input
            className='w-full border-none py-2 pl-3 pr-10 focus:ring-0 text-sm leading-5 text-gray-900'
            displayValue={(org: NamedItem) => org.name}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Combobox.Button className='absolute inset-y-0 right-0 flex items-center pr-2'>
            <ChevronDownIcon className='h-5 w-5 text-gray-400' />
          </Combobox.Button>
        </div>
        <Combobox.Options className='absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm'>
          {filteredOption.length === 0 && query != '' ? (
            <div className='relative cursor-default select-none py-2 px-4 text-gray-700'>Noting found.</div>
          ) : (
            filteredOption.map((org) => (
              <Combobox.Option key={org.id} value={org}>
                <div className='px-3 py-2 hover:bg-blue-50 cursor-pointer'>{org.name}</div>
              </Combobox.Option>
            ))
          )}
        </Combobox.Options>
      </div>
    </Combobox>
  )
}

export default OrganizationCombobox
